import React from "react";

interface SessionLoadingProps {
  message?: string;
}

export const SessionLoading: React.FC<SessionLoadingProps> = ({
  message = "Loading session...",
}) => {
  return (
    <div className="flex items-center justify-center min-h-dvh">
      <div className="text-center">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-ac mx-auto mb-4"></div>
        <p className="text-gray-600">{message}</p>
      </div>
    </div>
  );
};
